import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import {
  adaptExercisesToStore,
  adaptExerciseToApi,
  adaptExerciseToStore,
  adaptTestsToStore,
  adaptTestToStore,
  adaptTestToApi,
  adaptSolutionsToStore,
  adaptSolutionToStore,
  adaptSolutionToApi
} from './adapters/exerciseAdapter'

import { EXERCISES } from '@/services/axios.config'

const services = [
  {
    name: 'listExercises',
    method: 'get',
    url: (params) => `/exercises${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptExercisesToStore
  },
  {
    name: 'getExercise',
    method: 'get',
    url: (params) => `/exercises/${params.exerciseId}`,
    resolver: adaptExerciseToStore
  },
  {
    name: 'createExercise',
    method: 'post',
    url: () => `/exercises`,
    data: (params) => {
      return adaptExerciseToApi(params)
    },
    resolver: adaptExerciseToStore
  },
  {
    name: 'editExercise',
    method: 'patch',
    url: (params) => `/exercises/${params.exerciseId}`,
    data: (params) => {
      return adaptExerciseToApi(params)
    },
    resolver: adaptExerciseToStore
  },

  {
    name: 'listTests',
    method: 'get',
    url: (params) => `/exercises/${params.exerciseId}/tests?page_size=30`,
    resolver: adaptTestsToStore
  }, {
    name: 'getTest',
    method: 'get',
    url: (params) => `/exercises/${params.exerciseId}/tests/${params.testId}`,
    resolver: adaptTestToStore
  }, {
    name: 'createTest',
    method: 'post',
    url: (params) => `/exercises/${params.exerciseId}/tests`,
    data: (params) => {
      return adaptTestToApi(params)
    },
    resolver: adaptTestToStore
  }, {
    name: 'editTest',
    method: 'patch',
    url: (params) => `/exercises/${params.exerciseId}/tests/${params.testId}`,
    data: (params) => {
      return adaptTestToApi(params)
    },
    resolver: adaptTestToStore
  }, {
    name: 'deleteTest',
    method: 'delete',
    url: (params) => `/exercises/${params.exerciseId}/tests/${params.testId}`,
  },

  {
    name: 'listSolutions',
    method: 'get',
    url: (params) => `/exercises/${params.exerciseId}/solutions?page_size=30`,
    resolver: adaptSolutionsToStore
  }, {
    name: 'getSolution',
    method: 'get',
    url: (params) => `/exercises/${params.exerciseId}/solutions/${params.solutionId}`,
    resolver: adaptSolutionToStore
  }, {
    name: 'createSolution',
    method: 'post',
    url: (params) => `/exercises/${params.exerciseId}/solutions`,
    data: (params) => {
      return adaptSolutionToApi(params)
    },
    resolver: adaptSolutionToStore
  }, {
    name: 'editSolution',
    method: 'patch',
    url: (params) => `/exercises/${params.exerciseId}/solutions/${params.solutionId}`,
    data: (params) => {
      return adaptSolutionToApi(params)
    },
    resolver: adaptSolutionToStore
  }, {
    name: 'deleteSolution',
    method: 'delete',
    url: (params) => `/exercises/${params.exerciseId}/solutions/${params.solutionId}`,
  }, {
    name: 'testSolution',
    method: 'post',
    url: (params) => `/exercises/${params.exerciseId}/attempts`,
    data: (params) => {
      return {
        submitted_code: params.submitted_code
      }
    },
    resolver: adaptSolutionToStore
  }
]

export const {
  listExercises,
  getExercise,
  createExercise,
  editExercise,
  listTests,
  getTest,
  createTest,
  editTest,
  deleteTest,
  listSolutions,
  getSolution,
  createSolution,
  editSolution,
  deleteSolution,
  testSolution,
} = buildServices(EXERCISES, services)